/* eslint-disable */
import React, { useState } from "react";

const styles = {
    backdrop: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.65)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        backdropFilter: "blur(4px)",
        animation: "fadeIn 0.2s ease",
    },
    modal: {
        background: "linear-gradient(160deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%)",
        borderRadius: "20px",
        boxShadow: "0 24px 64px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.1)",
        width: "100%",
        maxWidth: "560px",
        maxHeight: "90vh",
        overflowY: "auto",
        fontFamily: "'Inter', 'Roboto', sans-serif",
        animation: "scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
    },
    header: {
        padding: "24px 28px 20px",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    headerLeft: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    title: {
        color: "#ffffff",
        fontSize: "18px",
        fontWeight: "700",
        margin: 0,
        letterSpacing: "-0.3px",
    },
    closeBtn: {
        background: "rgba(255,255,255,0.08)",
        border: "none",
        borderRadius: "8px",
        color: "rgba(255,255,255,0.6)",
        cursor: "pointer",
        fontSize: "18px",
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.15s ease",
    },
    body: {
        padding: "20px 28px",
    },
    intro: {
        color: "rgba(255,255,255,0.65)",
        fontSize: "13.5px",
        lineHeight: "1.6",
        marginBottom: "20px",
    },
    categoryCard: {
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "12px",
        padding: "18px 20px",
        marginBottom: "12px",
        transition: "border-color 0.2s ease",
    },
    categoryCardActive: {
        background: "rgba(34,197,94,0.06)",
        border: "1px solid rgba(34,197,94,0.3)",
        borderRadius: "12px",
        padding: "18px 20px",
        marginBottom: "12px",
    },
    categoryHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "8px",
    },
    categoryLeft: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    categoryIcon: {
        fontSize: "20px",
    },
    categoryTitle: {
        color: "#ffffff",
        fontSize: "14.5px",
        fontWeight: "700",
        margin: 0,
    },
    categoryDesc: {
        color: "rgba(255,255,255,0.55)",
        fontSize: "12.5px",
        lineHeight: "1.55",
        margin: "0 0 10px 30px",
    },
    cookieList: {
        margin: "0 0 0 30px",
        padding: 0,
        listStyle: "none",
    },
    cookieItem: {
        display: "flex",
        gap: "6px",
        alignItems: "flex-start",
        marginBottom: "4px",
    },
    cookieDot: {
        color: "rgba(255,255,255,0.3)",
        fontSize: "10px",
        marginTop: "5px",
        flexShrink: 0,
    },
    cookieName: {
        color: "rgba(255,255,255,0.45)",
        fontSize: "11.5px",
        fontFamily: "monospace",
    },
    lockBadge: {
        background: "rgba(255,255,255,0.1)",
        color: "rgba(255,255,255,0.5)",
        fontSize: "11px",
        fontWeight: "600",
        padding: "3px 10px",
        borderRadius: "20px",
        letterSpacing: "0.3px",
    },
    toggle: (active) => ({
        position: "relative",
        width: "46px",
        height: "26px",
        borderRadius: "13px",
        background: active ? "linear-gradient(135deg, #22c55e, #16a34a)" : "rgba(255,255,255,0.15)",
        border: "none",
        cursor: "pointer",
        transition: "background 0.2s ease",
        flexShrink: 0,
        boxShadow: active ? "0 2px 8px rgba(34,197,94,0.35)" : "none",
    }),
    toggleThumb: (active) => ({
        position: "absolute",
        top: "3px",
        left: active ? "23px" : "3px",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        background: "#ffffff",
        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
        transition: "left 0.2s cubic-bezier(0.16, 1, 0.3, 1)",
    }),
    footer: {
        padding: "20px 28px 24px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
    },
    btnSave: {
        flex: 1,
        background: "linear-gradient(135deg, #22c55e, #16a34a)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "12px 20px",
        fontSize: "14px",
        fontWeight: "700",
        cursor: "pointer",
        fontFamily: "'Inter', 'Roboto', sans-serif",
        boxShadow: "0 4px 12px rgba(34,197,94,0.3)",
        transition: "all 0.2s ease",
    },
    btnAcceptAll: {
        background: "rgba(255,255,255,0.08)",
        color: "#fff",
        border: "1px solid rgba(255,255,255,0.15)",
        borderRadius: "10px",
        padding: "12px 18px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer",
        fontFamily: "'Inter', 'Roboto', sans-serif",
        transition: "all 0.2s ease",
    },
    keyframes: `
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.94); } to { opacity: 1; transform: scale(1); } }
    `,
};

const CATEGORIES = [
    {
        key: "necessary",
        icon: "🔒",
        title: "Necesare",
        description:
            "Esențiale pentru funcționarea site-ului. Nu pot fi dezactivate — nu colectează date de identificare personală.",
        cookies: [
            {
                name: "doral_cookie_consent",
                duration: "1 an",
                role: "Stochează preferințele tale de cookies",
            },
        ],
        locked: true,
    },
    {
        key: "analytics",
        icon: "📊",
        title: "Analitice",
        description:
            "Ne ajută să înțelegem cum interacționezi cu site-ul (pagini vizitate, durată sesiune). Toate datele sunt anonimizate.",
        provider: "Google Analytics 4",
        cookies: [
            { name: "_ga", duration: "2 ani", role: "Identificator unic vizitator (anonim)" },
            { name: "_ga_*", duration: "2 ani", role: "Stochează starea sesiunii GA4" },
            { name: "_gid", duration: "24 ore", role: "Identificator sesiune curentă" },
            { name: "_gat", duration: "1 minut", role: "Limitează rata de cereri" },
        ],
        locked: false,
    },
    {
        key: "marketing",
        icon: "📢",
        title: "Marketing",
        description:
            "Folosite pentru a măsura eficiența campaniilor publicitare și pentru a afișa reclame relevante.",
        provider: "",
        cookies: [],
        locked: false,
    },
];

function Toggle({ active, onChange, disabled }) {
    return (
        <button
            style={styles.toggle(active)}
            onClick={() => !disabled && onChange(!active)}
            disabled={disabled}
            aria-label={active ? "Dezactivează" : "Activează"}
        >
            <div style={styles.toggleThumb(active)} />
        </button>
    );
}

function CookieSettingsModal({ consent, onSave, onClose }) {
    const [local, setLocal] = useState({
        necessary: true,
        analytics: consent.analytics || false,
        marketing: consent.marketing || false,
    });

    const [expanded, setExpanded] = useState(null);

    const handleToggle = (key, value) => {
        setLocal((prev) => ({ ...prev, [key]: value }));
    };

    return (
        <>
            <style>{styles.keyframes}</style>
            <div style={styles.backdrop} onClick={(e) => e.target === e.currentTarget && onClose()}>
                <div style={styles.modal}>
                    {/* Header */}
                    <div style={styles.header}>
                        <div style={styles.headerLeft}>
                            <span style={{ fontSize: "22px" }}>⚙️</span>
                            <h2 style={styles.title}>Preferințe Cookie</h2>
                        </div>
                        <button style={styles.closeBtn} onClick={onClose} aria-label="Închide">
                            ✕
                        </button>
                    </div>

                    {/* Body */}
                    <div style={styles.body}>
                        <p style={styles.intro}>
                            Alege ce categorii de cookie-uri accepți. Cookie-urile necesare sunt
                            întotdeauna active, deoarece sunt esențiale pentru funcționarea
                            site-ului.
                        </p>

                        {CATEGORIES.map((cat) => {
                            const isActive = local[cat.key];
                            const isExpanded = expanded === cat.key;
                            return (
                                <div
                                    key={cat.key}
                                    style={
                                        isActive && !cat.locked
                                            ? styles.categoryCardActive
                                            : styles.categoryCard
                                    }
                                >
                                    <div style={styles.categoryHeader}>
                                        <div style={styles.categoryLeft}>
                                            <span style={styles.categoryIcon}>{cat.icon}</span>
                                            <span style={styles.categoryTitle}>{cat.title}</span>
                                            {cat.provider && (
                                                <span
                                                    style={{
                                                        color: "rgba(255,255,255,0.35)",
                                                        fontSize: "11px",
                                                        marginLeft: "4px",
                                                    }}
                                                >
                                                    ({cat.provider})
                                                </span>
                                            )}
                                        </div>
                                        {cat.locked ? (
                                            <span style={styles.lockBadge}>Mereu activ</span>
                                        ) : (
                                            <Toggle
                                                active={isActive}
                                                onChange={(v) => handleToggle(cat.key, v)}
                                                disabled={false}
                                            />
                                        )}
                                    </div>

                                    <p style={styles.categoryDesc}>{cat.description}</p>

                                    {/* Expand/collapse cookies list */}
                                    {cat.cookies.length > 0 && (
                                        <>
                                            <button
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    color: "rgba(255,255,255,0.35)",
                                                    fontSize: "11.5px",
                                                    cursor: "pointer",
                                                    marginLeft: "30px",
                                                    padding: 0,
                                                    fontFamily: "'Inter', 'Roboto', sans-serif",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                }}
                                                onClick={() => setExpanded(isExpanded ? null : cat.key)}
                                            >
                                                {isExpanded ? "▲" : "▼"} {isExpanded ? "Ascunde" : "Vezi"}{" "}
                                                cookie-urile ({cat.cookies.length})
                                            </button>

                                            {isExpanded && (
                                                <ul style={{ ...styles.cookieList, marginTop: "10px" }}>
                                                    {cat.cookies.map((c) => (
                                                        <li key={c.name} style={styles.cookieItem}>
                                                            <span style={styles.cookieDot}>●</span>
                                                            <span style={styles.cookieName}>
                                                                <strong
                                                                    style={{
                                                                        color: "rgba(255,255,255,0.6)",
                                                                    }}
                                                                >
                                                                    {c.name}
                                                                </strong>{" "}
                                                                — {c.duration} — {c.role}
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                    {/* Footer */}
                    <div style={styles.footer}>
                        <button
                            id="cookie-save-settings"
                            style={styles.btnSave}
                            onClick={() => onSave(local)}
                            onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
                            onMouseLeave={(e) => (e.target.style.opacity = "1")}
                        >
                            Salvează preferințele
                        </button>
                        <button
                            style={styles.btnAcceptAll}
                            onClick={() =>
                                onSave({ necessary: true, analytics: true, marketing: true })
                            }
                            onMouseEnter={(e) =>
                                (e.target.style.background = "rgba(255,255,255,0.14)")
                            }
                            onMouseLeave={(e) =>
                                (e.target.style.background = "rgba(255,255,255,0.08)")
                            }
                        >
                            Acceptă toate
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CookieSettingsModal;
